import { ShouldUpdateScrollArgs } from 'gatsby';

export const shouldUpdateScroll: (arg0: ShouldUpdateScrollArgs) => boolean = ({ routerProps }) => {
  if (routerProps.location.state && routerProps.location.state.skipScroll) {
    return false;
  }

  return true;
};
